import { isNotNilOrEmpty } from "client/Misc/utils";
import {
	DOMOutputSpec,
	Mark,
	MarkSpec
} from "prosemirror-model";

export type MentionNodeAttributes = {
	type: string;
	value: string | null;
};

export const mention: MarkSpec = {
	inclusive: false,
	// This is a shorthand indicating that it should exclude all marks
	// https://prosemirror.net/docs/ref/#model.MarkSpec.excludes
	excludes: "_",
	attrs: {
		type: {},
		value: { default: null }
	},
	parseDOM: [
		{
			tag: "mark",
			getAttrs(dom: string | Node): MentionNodeAttributes | false {
				if (!(dom instanceof HTMLElement)) {
					throw new Error("Expected HTMLElement at this point");
				}

				const {
					mention,
					value
				} = dom.dataset;

				if (isNotNilOrEmpty(mention)) {
					return {
						type: mention,
						value: value ?? null
					};
				}

				return false;
			},
		}
	],
	toDOM(node: Mark): DOMOutputSpec {
		const {
			type,
			value
		} = (node.attrs as MentionNodeAttributes);

		return [
			"mark",
			{
				"data-mention": type,
				"data-value": value
			},
			0
		];
	}
};